'use strict'

import angular from 'angular'
import _ from 'lodash'
import $ from 'jquery'

import buySheetMainComponentHtmlUrl from './buySheetMain.component.html'

angular.module('buySheet.components').component('buySheetMain', {
    templateUrl: buySheetMainComponentHtmlUrl,
    bindings: {
        orderId: '<',
        buySheetData: '<',
        mayExportBuySheetToExcel: '<',
        notice: '<',
        onRegenerate: '&',
        onExportToPdf: '&',
        onExportToXlsx: '&',
    },
    controller($rootScope, $timeout, $window) {
        let buySheetData,
            count = 0

        this.$onChanges = () => {
            buySheetData = this.buySheetData
            _.assign(this, buySheetData)
            this.productsTablesHeaders = extractProductTableHeadersOnViewModel(buySheetData)
            this.flightsTablesHeaders = extractFlightTableHeaderOnViewModel(buySheetData)
            this.isPriting = false
        }

        function extractProductTableHeadersOnViewModel(dataFromServer) {
            return extractEntityTableHeadersOnViewModel(dataFromServer, 'products')
        }

        function extractEntityTableHeadersOnViewModel(dataFromServer, entityName) {
            if (!dataFromServer || !dataFromServer[entityName]) {
                return {}
            }

            let returned = {}
            _.each(dataFromServer[entityName], function (entity) {
                let headers = []
                _.each(entity.data[_.first(_.keys(entity.data))], function (datum) {
                    headers.push(datum.display_name)
                })
                returned[entity.name] = headers
            })

            return returned
        }

        function extractFlightTableHeaderOnViewModel(dataFromServer) {
            return extractEntityTableHeadersOnViewModel(dataFromServer, 'flights')
        }

        this.regenerate = () => {
            this.onRegenerate()
        }

        this.downloadAsPdf = () => {
            this.onExportToPdf()
        }

        this.downloadAsXlsx = () => {
            if (this.mayExportBuySheetToExcel) {
                this.onExportToXlsx()
            }
        }

        this.openInNewWindow = () => {
            let $element = $(`#buy-sheet-${this.orderId}`),
                $newDoc = $($window.open().document),
                $newDocHead = $newDoc.find('head')

            $newDocHead.append('<meta charset="utf-8">')
            $newDocHead.append('<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1">')

            let $bootstrap = $('<link rel="stylesheet" href="https://stackpath.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css" integrity="sha384-HSMxcRTRxnN+Bdg0JdbxYKrThecOKuH5zCYotlSAcp1+c8xmyTe9GYg1l9a69psu" crossorigin="anonymous">')
            $newDocHead.append($bootstrap)

            let $overrideStyle = $('<style type="text/css">.panel-default>.panel-heading{background-color: white}</style>')
            $newDocHead.append($overrideStyle)

            let $clone = $element.clone()
            $clone.find('#buy-sheet-logo').attr('src', buySheetData.logo_url_light)

            let $newBody = $newDoc.find('body')
            $newBody.addClass('container-fluid')
            $newBody.append($clone)
        }

        this._addBreakOnSimpleFieldsList = (property) => {
            this[property] = loopOverOriginalFields(buySheetData[property])
        }

        function loopOverOriginalFields(fields) {
            let returned = []

            _.forEach(fields, (field) => {
                pushField(returned, field)
            })

            return returned
        }


        function pushField(fields, field) {
            switch (field.rendering_type) {
                case 'geo_location':
                    pushGeoLocationsField(fields, field)
                    break
                default:
                    pushSimpleField(fields, field)
                    break
            }
        }

        function pushGeoLocationsField(fields, field) {
            let originalGeoData = JSON.parse(field.value),
                geoData = {Locations: [], "Text inputs": []},
                clonedField = _.clone(field),
                space_between_geo_sections = 1

            count += space_between_geo_sections
            loopOverGeoLocationsSection('Locations', originalGeoData, geoData)
            count += space_between_geo_sections
            loopOverGeoLocationsSection('Text inputs', originalGeoData, geoData)

            clonedField.value = geoData

            fields.push(clonedField)
        }

        function loopOverGeoLocationsSection(section, originalGeoData, geoData) {
            _.forEach(originalGeoData[section], (value) => {
                geoData[section].push(value)
                count++
            })
        }

        function pushSimpleField(fields, field) {
            fields.push(field)
            count++
        }
    },
    controllerAs: 'vm'
})